import gql from 'graphql-tag';

export const GET_BIO = `
query($is_Draft :Boolean $completed_id : Int){
  me{
    biosYours(Inputs: {
      is_Draft : $is_Draft
      completed_id : $completed_id
    }, first: 1000){
      data{
        id
        title
        is_Draft
        completed {id}
        speciality{id name_en}
        brif
        tags
        bioTagsNames
        video{id url frame{url} }
        share_able_link
        has_application
        is_my_profile_visume
        questions{
          id 
          title
          video{id url frame{url}}
        }
      }
    }
  }
}
`
export const GET_BIO_HOME = gql`
query($is_Draft :Boolean $completed_id : Int){
  me{
    biosYours(Inputs: {
      is_Draft : $is_Draft
      completed_id : $completed_id
    }, first: 1000){
      data{
        id
        title
        is_Draft
        completed {id}
        speciality{id name_en}
        brif
        tags
        bioTagsNames
        video{id url frame{url} duration}
        share_able_link
        has_application
        is_my_profile_visume
        questions{
          id 
          title
          video{id url frame{url} }
        }
      }
    }
  }
}
`